import axios from 'axios';
import {ACCESS_TOKEN_NAME} from "@/constant";
import {authLogout} from "@/security/index";
const API_PATH = process.env.API_ENDPOINT;
export default {
    getApi(path, data, options, successCallBack, errorCallBack, isEnableLoading, parrentLoading) {
        // eslint-disable-next-line no-undef
        $('.btn-call-ajax').css('pointer-events', 'none');
        if (isEnableLoading) {
            this.showLoading(parrentLoading);
        }
        axios.get(API_PATH + path, data, options).then(response => {
            successCallBack(response);
            // eslint-disable-next-line no-undef
            $('.btn-call-ajax').css('pointer-events', 'all');
            if (isEnableLoading) {
                this.removeLoading(parrentLoading);
            }
        }).catch(error => {
            errorCallBack(error);
            // eslint-disable-next-line no-undef
            $('.btn-call-ajax').css('pointer-events', 'all');
            if (isEnableLoading) {
                this.removeLoading(parrentLoading);
            }
        });
    },
    handleError(router, error) {
        if (error && error.response && error.response.status === 401 || error && error.status === 401) {
            authLogout();
        } else if (error && error.response && error.response.status === 403 || error && error.status === 403) {
            router.push('/errors/403');
        } else if (error && error.response && error.response.status === 500 || error && error.status === 503 || error && error.status === 400) {
            router.push('/errors/500');
        } else if(error.returnCode === undefined){
            authLogout();
        }
    },
    setupErrorModel(errorResponse, dataRef) {
        if (!errorResponse instanceof Array ) {
            return;
        }
        for (let attr in dataRef) {
            var attrValue = dataRef[attr];
            if(attrValue['data'] && attrValue['data']['name'] &&
             attrValue['data']['validator'] && errorResponse[attrValue['data']['name']]) {
                attrValue['data']['validator']['isValid'] = false;
                attrValue['data']['validator']['errorMessage'] = errorResponse[attrValue['data']['name']];
            }
        }
    },
    getStringError(errorResponse) {
        let strResult = '';
        if (typeof errorResponse === 'string') {
            return errorResponse;
        }
        for (let attr in errorResponse) {
            strResult += errorResponse[attr] + ', '
        }
        if(strResult) {
            strResult = strResult.substring(0, strResult.length - 2);
        } else {
            strResult = 'Hệ thống đang bận, xin thử lại sau ít phút';
        }
        return strResult;
    },
    validResponse(router, response) {
        if (response.returnCode !== 1) {
            this.handleError(router, response);
            return false;
        } else {
            return true;
        }
    },
    getValue(component) {
        return component.data.model;
    },
    setValue(component, value) {
        component.data.model = value;
    },
    getFirstOptionValue(component) {
        return component.getFirstOptionValue();
    },
    setFirstOptionSelected(component) {
        component.setFirstOptionSelected();
    },
    getText(component) {
        return component.getText;
    },
    enterEventHandler(event, callBack) {
        if (event.key === 'Enter') {
            callBack();
        }
    },
    setupDataSubmit(modelObject) {
        var dataSubmit = {};
        for (let attr in modelObject) {
            if (!(modelObject[attr].data && modelObject[attr].data.name && modelObject[attr].data.model !== undefined && modelObject[attr].data.formatter === undefined)) {
                continue;
            }
            let element = modelObject[attr];
            dataSubmit[element.data.name] = element.data.model;
        }
        return dataSubmit;
    },
    setupDataResponse(modelObject, dataResponse) {
        let response = {};
        for (let attr in modelObject) {
            if (!(modelObject[attr].data && modelObject[attr].data.name && modelObject[attr].data.model !== undefined)) {
                continue;
            }
            let element = modelObject[attr];
            let modelVal = dataResponse[element.data.name];
            if (!element.data.formatter) {
                response[element.data.name] = modelVal;
            }
            if (element.data.formatter) {
                modelVal = element.data.formatter(modelVal);
            }
            element.data.model = modelVal;
        }
        return response;
    },
    validDataSubmit(modelObject) {
        let isValid = true;
        for (let attr in modelObject) {
            if (!(modelObject[attr].data && modelObject[attr].data.name && modelObject[attr].data.validator !== undefined)) {
                continue;
            }
            let element = modelObject[attr];
            isValid &= element.data.validator.valid();
        }
        return isValid;
    },
    valid(component) {
        return component.data.validator.valid();
    },
    loadDataSource(dataSource) {
        var _dataSubmit;
        var hasDataRef = dataSource.dataRef !== undefined;
        var hasLoading = dataSource.loading !== undefined;
        var hasBtnCallAjax = typeof dataSource.btnCallAjaxs === "function" && dataSource.btnCallAjaxs().length !== 0;
        var that = this;
        if (dataSource.valid !== undefined && dataSource.valid == false) {
            return;
        }
        if (hasDataRef && !this.validDataSubmit(dataSource.dataRef())) {
            return;
        }
        if (dataSource.dataSubmit) {
            _dataSubmit = dataSource.dataSubmit();
        }
        if (hasDataRef) {
            _dataSubmit = this.setupDataSubmit(dataSource.dataRef());
        }
        if (hasDataRef && dataSource.dataValid && this.isDataClone(dataSource.dataValid(), _dataSubmit)) {
            if (dataSource.validFalseCallback) {
                dataSource.validFalseCallback();
            }
            return;
        }
        if (hasLoading) {
            dataSource.loading.value = true;
        }
        if (hasBtnCallAjax) {
            for (let btn of dataSource.btnCallAjaxs()) {
                btn.disabled = true;
            }
        }
        var _successCallback = function (response) {
            if (hasLoading) {
                dataSource.loading.value = false;
            }
            if (hasBtnCallAjax) {
                for (let btn of dataSource.btnCallAjaxs()) {
                    btn.disabled = false;
                }
            }
            if (hasDataRef && dataSource.dataValid) {
                var dataCahce = dataSource.dataValid();
                that.copyProperties(dataCahce, _dataSubmit);
            }
            dataSource.successCallback(response);
        }
        var _errorCallback = function (error) {
            if (hasLoading) {
                dataSource.loading.value = false;
            }
            if (hasBtnCallAjax) {
                for (let btn of dataSource.btnCallAjaxs()) {
                    btn.disabled = true;
                }
            }
            dataSource.errorCallback(error);
        }
        this.postApi(dataSource.url, _dataSubmit, dataSource.options, dataSource.isJsonContentType, _successCallback, _errorCallback);
    },

    postApi(path, data, options, isJsonContentType, successCallBack, errorCallBack) {
        options = options || {};
        options.headers = options.headers || {};
        if (isJsonContentType === undefined) {
            isJsonContentType = true;
        }
        let _dataSubmit = null;
        let defaultHeader = {
            'Authorization': 'Bearer ' + this.getAccessToken(),
        }
        let customHeaders = $.extend(defaultHeader, options.headers);

        options.headers = customHeaders;

        if (data && isJsonContentType) {
            _dataSubmit = data;
            options.headers['content-type'] = 'application/json;charset=utf-8';
        } else if (data && data instanceof Object) {
            options.headers['content-type'] = 'application/x-www-form-urlencoded;charset=utf-8';
            _dataSubmit = '';
            for (var attrName in data) {
                _dataSubmit += attrName + '=' + data[attrName] + '&';
            }
            _dataSubmit = _dataSubmit.substring(0, _dataSubmit.length - 1);
        } else if (data) {
            options.headers['content-type'] = 'application/x-www-form-urlencoded;charset=utf-8';
            _dataSubmit = data;
        }

        axios.post(API_PATH + path, _dataSubmit, options).then(response => {
            successCallBack(response);
        }).catch(error => {
            console.log(error);
            errorCallBack(error);
        });
    },
    postApiAjax(path, data, options, successCallBack, errorCallBack) {
        let defaultHeader = {
            'Authorization': 'Bearer ' + this.getAccessToken(),
            // 'Access-Control-Allow-Origin' : '*'
        }
        // eslint-disable-next-line no-undef
        let customOptions = $.extend(defaultHeader, options.headers);
        options.headers = customOptions;
        $.ajax({
            type: "POST",
            url: API_PATH + path,
            headers: customOptions,
            data: data,
            async: false,
            success: function (res) {
                successCallBack(res);
            },
            error: function (res) {
                errorCallBack(res);
            }
        });
    },
    setAccessToken(access_token) {
        localStorage.setItem('access_token', access_token);
    },
    getAccessToken() {
        return localStorage.getItem(ACCESS_TOKEN_NAME);
    },
    setAuthorities(Authorities) {
        localStorage.setItem('Authorities', Authorities);
    },
    setUsername(username) {
        localStorage.setItem('username', username);
    },
    clearAccessToken() {
        localStorage.clear();
    },
    checkLogin() {
        let token = localStorage.getItem('access_token');
        return token !== null & typeof token !== 'undefined';
    },
    formatDate(milisecons) {
        if (milisecons === null || milisecons === '') {
            return '';
        } else {
            var moment = require('moment');
            return moment(milisecons).format("DD/MM/YYYY HH:mm:ss");
        }
    },
    formatDateDDMMYYYYHHMM(milisecons) {
        if (milisecons === null || milisecons === '') {
            return '';
        } else {
            var moment = require('moment');
            return moment(milisecons).format("DD/MM/YYYY HH:mm");
        }
    },
    formatDateDDMMYYYY(milisecons) {
        if (milisecons === null || milisecons === '') {
            return '';
        } else {
            var moment = require('moment');
            return moment(milisecons).format("DD/MM/YYYY");
        }
    },
    formatDateYYYYMMDD(milisecons) {
        if (milisecons === null || milisecons === '') {
            return '';
        } else {
            var moment = require('moment');
            return moment(milisecons).format("YYYY-MM-DD");
        }
    },
    formatPrice(value) {
        if (value === null || value === '') {
            return '';
        } else {
            let val = (value / 1).toFixed(0).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }
    },
    formatPriceString(priceStr) {
        if (priceStr === null || priceStr === '') {
            return '';
        } else {
            if (typeof priceStr === 'number') {
                priceStr = priceStr.toString();
                if (priceStr.startsWith('-')) {
                    priceStr = priceStr.substring(1, priceStr.length);
                }
            }
            return priceStr.replace(/(?=(?:\d{3})+$)(?!^)/g, ',');
        }
    },
    formatNumberString(numberStr) {
        if (numberStr === null || numberStr === '') {
            return '';
        } else {
            if (typeof numberStr === 'number') {
                numberStr = numberStr.toString();
            }
            return numberStr.replace(/(?=(?:\d{3})+$)(?!^)/g, ',');
        }
    },
    setupInputNumberRequired(inputId, isFormatNumber) {
        let that = this,
            // eslint-disable-next-line no-undef
            $input = $('#' + inputId);
        if (isFormatNumber !== false) {
            $input.on('keyup', function () {
                let formattedVal = that.formatNumberString($input.val().replace(/,/g, ''));
                $input.val(formattedVal);
            });
        }

        $input.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
            if (/^\d*$/.test(this.value.replace(/,/g, ''))) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
        });
    },
    setupInputNumber(inputCLass) {
        // eslint-disable-next-line no-undef
        let $input = $('.' + inputCLass);
        $input.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
            if (/^\d*$/.test(this.value.replace(/,/g, ''))) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
        });
    },
    readBase64FromInput(id, objectResult, attrContent, callback) {
        let reader = new FileReader();
        reader.readAsDataURL(document.getElementById(id).files[0]);
        reader.onload = function () {
            objectResult[attrContent] = reader.result.split(',')[1];
            if (callback !== undefined) {
                callback();
            }
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    },
    isEmpty(myObject) {
        for (var key in myObject) {
            if (myObject.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    },
    setupTitleAction(action, object_type, object_name) {
        return `<span class="text-modal-important">${action}</span>&nbsp;${object_type}${object_name ? `&nbsp;<span class="text-modal-important">${object_name}</span>` : ''}`;
    },
    cloneObject(obj) {
        let copy;
        // Handle the 3 simple types, and null or undefined
        if (null == obj || "object" != typeof obj) {
            return obj;
        }
        if (obj instanceof Date) { // Handle Date
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }
        if (obj instanceof Array) { // Handle Array
            copy = [];
            for (let i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.cloneObject(obj[i]);
            }
            return copy;
        }
        if (obj instanceof Object) { // Handle Object
            copy = {};
            for (let attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = this.cloneObject(obj[attr]);
            }
            return copy;
        }
        throw new Error("Unable to copy obj! Its type isn't supported.");
    },
    copyProperties(targetObj, sourceObj) {
        for (let attr in sourceObj) {
            targetObj[attr] = sourceObj[attr];
        }
    },
    isDataClone(thisValue, thatValue) {
        for (let thisAttrName in thisValue) {
            let thisAttrValue = thisValue[thisAttrName];
            let thatAttrValue = thatValue[thisAttrName];
            if (thisAttrValue instanceof Array && thisAttrValue.length !== thatAttrValue.length) {
                return false;
            }
            if (!(thisAttrValue instanceof Object) && thisAttrValue != thatAttrValue) {
                return false;
            } else if (thisAttrValue instanceof Object) {
                return this.isDataClone(thisAttrValue, thatAttrValue);
            }
        }
        return true;
    },
}
